import assign from 'object-assign';
import {USER_REQUEST, USER_SUCCESS, USER_FAILURE} from '../action/loadUser';
import {API_CODE_USER_NOT_LOGIN} from '../config';
export default (state = {
	isFetching: false,
  isLogin: null,
	isFail: null,
}, action) => {
  switch (action.type) {
    case USER_REQUEST:
      return assign({}, state, {
        isFetching: true
      });
    case USER_SUCCESS:
      return assign({}, state, action.response.result.user, {
        isFetching: false,
        isLogin: true,
      });
    case USER_FAILURE:
      if (action.code === API_CODE_USER_NOT_LOGIN)
      {
	      return assign({}, state, {
		      isFetching: false,
		      isLogin: false,
	      });
      }
      else
      {
	      return assign({}, state, {
		      isFetching: false,
          isFail: true,
	      });
      }
	  default:
		  if (action.code === 100002) {
			  return {
				  isFetching: false,
				  isLogin: false,
				  loaded: true
			  };
		  }
		  return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducer/user.js